<template>
  <base-dialog
    v-model="dialog"
    title="Uusi yksikkö"
    icon="mdi-account-plus"
    :valid-form="validForm"
    :is-loading="isLoading"
    @cancel="handleCancel"
    @save="createUnit"
  >
    <template #content>
      <v-form v-model="validForm">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              label="Tunnus"
              filled
              hint='esimerkiksi "EME 1211"'
              required
              :rules="$rules.required"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="description"
              label="Kuvaus"
              filled
              hint='esimerkiksi "Ensihoitoyksikkö, Kotka"'
              required
              :rules="$rules.required"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-radio-group v-model="type" label="Tyyppi">
              <v-radio label="Virtuaaliyksikkö" :value="2"></v-radio>
              <v-radio label="VIRVE-yksikkö" :value="1"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row v-if="type == 1">
          <v-col cols="12">
            <v-text-field
              v-model="identifier"
              label="VIRVE-tilaajanumero"
              placeholder="esim. 1234567"
              outlined
              required
              autocomplete="off"
              :rules="$rules.required"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </base-dialog>

  <v-btn color="white" small text @click="newUnit">
    <v-icon size="small">mdi-plus</v-icon>
    Uusi yksikkö
  </v-btn>
</template>

<style lang="sass" scoped></style>
<script>
import BaseDialog from "./BaseDialog.vue";
import FormMixin from "@/mixins/FormMixin";

export default {
  components: { BaseDialog },
  mixins: [FormMixin],
  props: {
    inModal: Boolean
  },
  data: () => ({
    validForm: false,
    dialog: false,
    isLoading: false
  }),
  computed: {
    id: {
      get() {
        return this.$store.state.units.editor.id;
      },
      set(value) {
        this.$store.commit("units/set", ["editor.id", value]);
      }
    },
    name: {
      get() {
        return this.$store.state.units.editor.name;
      },
      set(value) {
        this.$store.commit("units/set", ["editor.name", value]);
      }
    },
    description: {
      get() {
        return this.$store.state.units.editor.description;
      },
      set(value) {
        this.$store.commit("units/set", ["editor.description", value]);
      }
    },
    type: {
      get() {
        console.log("creator get " + this.$store.state.units.editor.type);
        return this.$store.state.units.editor.type;
      },
      set(value) {
        console.log("creator set " + value);
        this.$store.commit("units/set", ["editor.type", value]);
      }
    },
    identifier: {
      get() {
        return this.$store.state.units.editor.identifier;
      },
      set(value) {
        this.$store.commit("units/set", ["editor.identifier", value]);
      }
    }
  },
  watch: {
    validForm(value) {
      this.$emit("is-valid", value);
    }
  },
  methods: {
    async newUnit() {
      const me = this;
      await me.$store.commit("units/newUnitToEditor", me.$store.state);
      me.dialog = true;
    },
    async createUnit() {
      const me = this;
      try {
        me.isLoading = true;
        const unit = await me.$store.dispatch("units/createUnit");
        me.$toast({
          type: "success",
          message: `Uusi yksikkö '${unit.name} - ${unit.description}' on tallennettu`
        });
        me.isLoading = false;
        me.dialog = false;
        await me.$store.dispatch("units/load");
      } catch (err) {
        if (err.message !== "cancel") {
          me.$error(err);
        }
        me.isLoading = false;
      }
    },
    handleCancel() {
      this.dialog = false;
    }
  }
};
</script>
